import React from 'react';

function Login() {
  return (
    <div className="login">
      <a href="#">Login</a>
      <a href="#" className="create-account">Create Account</a>
      <i class="fa-solid fa-gear"></i>
    </div>
  );
}

export default Login;